import { CloseOutlined } from "@ant-design/icons";
import { useCallback, useRef, useState, useEffect } from "react";
import { urls } from "../../../constants";
import { Wrapper, CloseButton } from "./elements";
import DocViewer, { PDFRenderer, IDocument, DocRenderer } from "@ccrichards1996/react-doc-viewer";

type Props = {
  src: string;
  onLoadDocument?: (loading: boolean) => void;
  closePopup: () => void;
  isOpen?: boolean;
}

const MSDocRenderer: DocRenderer = ({ mainState: { currentDocument }, }) => {
  if (!currentDocument)
    return null;

  const encodedURI = encodeURIComponent(currentDocument.uri as string);
  const documentSrc = `${urls.docMSOfficeViewerEmbed}?src=${encodedURI}`;

  return (
    <iframe
      id="msdoc-iframe"
      title="msdoc-iframe"
      src={documentSrc}
      sandbox="allow-same-origin allow-presentation allow-scripts allow-forms allow-top-navigation allow-top-navigation-by-user-activation"
      width="100%"
      height="100%"
    />
  );
};
MSDocRenderer.fileTypes = ["doc", "docx"];
MSDocRenderer.weight = 1;

const DocumentViewerPopup = ({ src, closePopup, isOpen, onLoadDocument = () => {} }: Props) => {
  const [iframeTimeout, setIframeTimeout] = useState<any>();
  const iframeRef = useRef<HTMLIFrameElement>(null);
  const [docs, setDocs] = useState<IDocument[]>([]);

 
  const handleSrcFile = useCallback(() => {
    const encodedURI = encodeURIComponent(src);
    return `${urls.docViewer}?embedded=true&url=${encodedURI}`;
  }, [src]);

  const handleLoadIframeSrc = useCallback(
    () => {
      if (iframeRef.current) {
        iframeRef!.current!.src = handleSrcFile();
      }
    }, [handleSrcFile]);

  const handleIframeLoaded = () => {
      const iframeContentLoaded = iframeRef.current?.contentWindow?.length;
      if (!!iframeContentLoaded) {
        clearInterval(iframeTimeout);
        onLoadDocument(false);
      } else {
        handleLoadIframeSrc();
      }
  }

  const getFileType = useCallback(
    () => {
      const fileType = src.match(/(pdf|rtf|doc|docx)/);
      setDocs([{ uri: src, fileType: fileType ? fileType[0] : 'docx' }]);

      if (fileType && fileType[0] === 'rtf') {
        const interval = setInterval(handleLoadIframeSrc, 1000 * 3);
        setIframeTimeout(interval);
      } else {
        onLoadDocument(false);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [handleLoadIframeSrc],
  )

  useEffect(() => {
    getFileType();
  }, [getFileType]);

  return (
    <Wrapper isOpen={isOpen}>
      <CloseButton 
        type="primary" 
        icon={<CloseOutlined />}
        onClick={closePopup}  
      />

  { docs.length && docs[0].fileType === 'rtf' ? 
      (
          <iframe
          title={src} 
          ref={iframeRef}
          src={handleSrcFile()}
          frameBorder="0"
          sandbox="allow-scripts allow-same-origin"
          height="100%"
          width="75%"
          marginHeight={0}
          marginWidth={0}
          onLoad={handleIframeLoaded}
          onError={handleLoadIframeSrc}
        />
      ) 
      : 
      (
        <DocViewer 
          style={{ height:"100%", width:"75%"}} 
          documents={docs} 
          pluginRenderers={[PDFRenderer, MSDocRenderer]} 
        />
      )
    }
        
     
    </Wrapper>
  )
}

export default DocumentViewerPopup;